import { Component, Input } from '@angular/core';

@Component({
  selector: 'seb-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent {

  @Input() backGroundColor: string = "white"
}
